<script setup lang="ts">
  withDefaults(defineProps<{ size?: number | string }>(), { size: 18 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12 7c-1.6-1.6-4-2.2-8-2.2v12.4c4 0 6.4.6 8 2.2 1.6-1.6 4-2.2 8-2.2V4.8c-4 0-6.4.6-8 2.2z" />
    <line x1="12" y1="7" x2="12" y2="19.4" />
  </svg>
</template>
